<template>
    <div class="base-mit-menu">
          <BaseMitMenuHeader v-if="userModel" :userModel="userModel"/>

            <v-divider></v-divider>

            <v-list nav dense>
                  <div v-if="userModel && userModel.role == userRoles.ADMIN">
                    <MitMenuAdmin/>
                  </div>
                  <div v-if="userModel && userModel.role >= userRoles.MANAGER">
                    <MitMenuManager/>
                  </div>
                  <div v-if="userModel && userModel.role >= userRoles.USER">
                    <MitMenuUser/>
                  </div>
                  <div>
                    <MitMenu/>
                  </div>
            </v-list>
            <v-divider></v-divider>
            <BaseMitMenuFooter v-if="userModel" :userModel="userModel" v-on:logout="logout" v-on:login="login"/>
      </div>
</template>

<script>
import BaseMitMenuHeader from './BaseMitMenuHeader.vue';
import BaseMitMenuFooter from './BaseMitMenuFooter.vue';

//IMPLEMENT THESE IN Custom APP
import MitMenuAdmin from '../../app/components/menu/MitMenuAdmin.vue';
import MitMenuManager from '../../app/components/menu/MitMenuManager.vue';
import MitMenuUser from '../../app/components/menu/MitMenuUser.vue';
import MitMenu from '../../app/components/menu/MitMenu.vue'; //No auth needed, open.

export default {
  name: 'BaseMitMenu',
  components: {
    BaseMitMenuHeader,
    BaseMitMenuFooter,
    MitMenuAdmin,
    MitMenuManager,
    MitMenuUser,
    MitMenu
  },
  props: {
    userModel: Object,
    userRoles: Object
  },
  methods : {
        login(){
          console.log(this.userModel);
          this.$emit('login');
        },
        logout() {
          this.$emit('logout');
        }
  }
}
</script>

<style lang="scss" scoped>
  .reverse-image {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
</style>
